import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHook"><Path fillRule="evenodd" clipRule="evenodd" d="M9 2C11.2091 2 13 3.79086 13 6C13 7.86384 11.7252 9.42998 10 9.87402V17C10 18.6569 11.3431 20 13 20C14.6569 20 16 18.6569 16 17V14.4141L14 16.4141L12.5859 15L18 9.58594V17C18 19.7614 15.7614 22 13 22C10.2386 22 8 19.7614 8 17V9.87402C6.27477 9.42998 5 7.86384 5 6C5 3.79086 6.79086 2 9 2ZM9 4C7.89543 4 7 4.89543 7 6C7 7.10457 7.89543 8 9 8C10.1046 8 11 7.10457 11 6C11 4.89543 10.1046 4 9 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHook;
